import { Outlet } from "react-router-dom";

import { ErrorBoundary } from "@/components/error-boundary";
import { FullPageLoading } from "@/components/full-page-loading";
import { Header } from "@/components/header";
import { Toaster } from "@/components/ui/toaster";
import { useLinkAuthBootstrap } from "@/hooks/use-link-auth-bootstrap";
import { useRouteAnalytics } from "@/hooks/use-route-analytics";

export function RootLayout() {
  const { ready } = useLinkAuthBootstrap();
  useRouteAnalytics();

  return (
    <div className="flex min-h-screen flex-col bg-neutral-25">
      <Header />
      <main className="flex-1">
        <ErrorBoundary>
          {ready ? <Outlet /> : <FullPageLoading />}
        </ErrorBoundary>
      </main>
      <Toaster />
    </div>
  );
}
